const MAX_PHONE_DIGITS = 11;

export function stripPhoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function applyPhoneMask(value: string): string {
  const digits = stripPhoneDigits(value).slice(0, MAX_PHONE_DIGITS);
  if (digits.length === 0) {
    return '';
  }
  if (digits.length <= 2) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
